const serviceStatus: { [key: number]: string } = {
  // 请求成功并且服务器创建了新的资源
  201: '请求成功并且服务器创建了新的资源',
  // 接受请求但没创建资源
  202: '接受请求但没创建资源',
  // 服务器不理解请求的语法
  400: '服务器不理解请求的语法',
  // 请求要求身份验证。 对于需要登录的网页，服务器可能返回此响应
  401: '请求要求身份验证。 对于需要登录的网页，服务器可能返回此响应',
  // 服务器拒绝请求
  403: 'token过期请重新登录',
  // 服务器找不到请求的网页
  404: '服务器找不到请求的路径',
  // (服务器内部错误) 服务器遇到错误，无法完成请求
  500: '服务器遇到错误，无法完成请求',
  // (错误网关) 服务器作为网关或代理，从上游服务器收到无效响应
  502: '服务器作为网关或代理，从上游服务器收到无效响应',
  // (服务不可用) 服务器目前无法使用(由于超载或停机维护)。 通常，这只是暂时状态。
  503: '服务器目前无法使用(由于超载或停机维护)',
  // (网关超时) 服务器作为网关或代理，但是没有及时从上游服务器收到请求
  504: '服务器作为网关或代理，但是没有及时从上游服务器收到请求'
}

export default serviceStatus
